import axios from "axios";
import {
  BASE_URL,
  CATEGORY_LIST,
  JOB_TYPE,
  JOB_TYPE_LIST,
  LOGIN,
  LOGOUT,
  ROLE_LIST,
  USER,
  USERS_LIST,
  MANUFACTURER,
  MANUFACTURER_LIST,
  PRODUCT_CATEGORIES,
  PRODUCT_CATEGORIES_LIST,
  TECHNICIANS_LIST,
  TECHNICIANS,
  SPECIALIZATION_LIST,
  CUSTOMER,
  CUSTOMER_LIST,
  PAYMENT_TERM_LIST,
  CUSTOMER_LOCATION,
  CUSTOMER_LOCATION_LIST,
  REGION_LIST,
  CITY_LIST,
  COUNTRY_LIST,
  PRODUCT,
  PRODUCT_LIST,
  CUSTOMER_DISCOUNT,
  CUSTOMER_DISCOUNT_LIST,
  SERVICE,
  SERVICE_LIST,
  TECHNICIAN_AVAILABILITY,
  TIME_SLOT,
  JOB,
  JOB_LIST,
  SPARE_PARTS_LIST,
  SPARE_PARTS,
  CUSTOMER_EQUIPMENT,
  CUSTOMER_EQUIPMENT_LIST,
  TECHNICIAN_LEAVE,
  TECHNICIAN_LEAVE_LIST,
  FORGET_PASSWORD,
  RESET_PASSWORD,
  VALIDATE_UUID_LINK,
  JOB_TIME_LINE,
  RESEND_EMAIL_INVITE,
  UPLOAD_JOB_FILES,
  QUOTATION_HISTORY,
  QUOTATION_DOWNLOAD,
  JOB_LOGS,
  TECHNICAL_REPORT,
  TECHNICAL_REPORT_MEDIA,
  AVAILABLE_TECH_DATES,
  RESCHEDULE_JOB,
  JOB_FEEDBACK,
  EXPORT_PRODUCT_CSV,
  QUOTATION,
  QUOTATION_LIST,
  QUOTATION_DISCOUNT,
  REQUEST_PARTS_LIST,
  CANCEL_JOB,
  GET_REQUESTED_LIST_BY_ID,
  UPDATE_REQUESTED_PARTS_STATUS,
  GET_PARTS_NOTES_BY_JOB_ID,
  UPDATE_PARTS_NOTES_BY_JOB_ID,
  COMPLETE_JOB,
  EQUIPMENT_MANUAL,
  GET_JOB_MEDIA,
  REQUOTE_QUOTATION,
  QUOTATION_REQUOTE_LIST,
  CUSTOMER_SERVICE_HISTORY,
  JOB_COMPLETED_OR_REWORK,
  DOWNLOAD_JOB_REPORT,
  EXPORT_PARTS_REQUESTED_CSV,
  CONTINUE_JOB,
  JOB_UNDER_WARRENTY,
  ADMIN_NOTE,
  ASSIGN_TECHNICIAN,
  VALIDATE_QUOTATION_UUID,
  APPROVE_AND_REJECT_QUOTATION,
  GENERATE_CHECKOUT_ID,
  GET_PAYMENT_STATUS,
  EDIT_SALES_ORDER_NUMBER,
  DOWNLOAD_JOB_MEDIA,
  DOWNLOAD_PRODUCT_MANUAL,
  RECORD_BANK_TRANSFER,
  DOWNLOAD_EQUIPMENT_INVOICE,
  PAYMENT_DETAILS,
  REOPEN_JOB,
  DOWNLOAD_PAYMENT_RECEIPT,
  INTERNAL_MONITORING,
  EXPORT_JOBS_CSV,
  EXPORT_SERVICES_CSV,
  EXPORT_SPARE_PARTS_CSV,
  ASSIGN_LOCATION_SUB_USER,
  DOWNLOAD_BULK_WORK_ORDER_REPORTS,
  DASHBOARD_JOB_STATUS,
  DASHBOARD_PAYMENT_STATUS,
  DASHBOARD_QUOTATION_REQUESTED_FOR_APPROVAL,
  DASHBOARD_SPARE_PARTS_READY_FOR_PICKUP,
  DASHBOARD_WORK_ORDER_LINE_CHART,
  DASHBOARD_ACTION_REQUIRED,
  DASHBOARD_REPORT,
  DASHBOARD_REPORT_EXPORT,
  DASHBOARD_ODOO_SUMMARY,
  DASHBOARD_ODOO_SYNC_SUMMARY_MANUFACTURAR,
  DASHBOARD_ODOO_SYNC_SUMMARY_CUSTOMERS,
  DASHBOARD_ODOO_SYNC_SUMMARY_SPARE_PARTS,
  DASHBOARD_ODOO_SYNC_SUMMARY_SERVICES,
  DASHBOARD_ODOO_SYNC_SUMMARY_QUOTATIONS,
  DASHBOARD_ACTION_REQUIRED_LIST,
  DASHBOARD_PAYMENT_STATUS_FAILED_AND_SUCCESS_LIST,
  DASHBOARD_QUOTATION_STATUS_COUNT,
  DASHBOARD_SPARE_PARTS_STATUS_COUNT,
  EXPORT_CSV,
  ODOO_SALES,
  ODOO_QUOTATION_COUNT,
  EXPORT_PAYMENT_LIST,
  DOWNLOAD_JOB_QUOTATION_ITEMS_CSV,
  DOWNLOAD_JOB_BULK_REPORTS,
  JOB_BULK_REPORTS_EXPORT_LIST,
  DOWNLOAD_COMPLETED_BULK_REPORTS,
  JOB_BULK_REPORTS_STATUS,
  BULK_REPORTS,
} from "./apiConstants";

const API = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const CsvAPI = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "csv/text",
  },
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

CsvAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

const API_FOR_PDF = axios.create({
  baseURL: BASE_URL,
  responseType: "blob",
});

API_FOR_PDF.interceptors.request.use((req) => {
  if (localStorage.getItem("p")) {
    req.headers.token = JSON.parse(localStorage.getItem("p")).token;
  }
  return req;
});

const API_FOR_DOWNLOAD = axios.create({
  baseURL: BASE_URL,
  // responseType: "blob",
  headers: {
    "Content-Type": "application/json",
  },
});

API_FOR_DOWNLOAD.interceptors.request.use((req) => {
  const storedData = localStorage.getItem("p");

  if (storedData) {
    req.headers.token = JSON.parse(storedData).token;
  }

  return req;
});

// Login API
export const user_login = (loginData) => API.post(`${LOGIN}`, loginData);

// Logout API
export const user_logout = () => API.post(LOGOUT);

//role list
export const role_list = () => API.get(ROLE_LIST);

//users
export const add_user = (bodyData) => API.post(`${USER}`, bodyData);

export const users_list = (pageNum, filters, searchString) =>
  API.get(USERS_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_user_by_ID = (id) => API.get(`${USER}${id}`);
export const edit_user = (id, bodyData) => API.patch(`${USER}${id}`, bodyData);
export const change_password = (id, bodyData) =>
  API.patch(`${USER}${id}/change-password`, bodyData);

//product-category
export const add_product_category = (bodyData) =>
  API.post(PRODUCT_CATEGORIES, bodyData);
export const product_category_list = (pageNum, filters) =>
  API.get(PRODUCT_CATEGORIES_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const edit_product_category = (id, bodyData) =>
  API.patch(`${PRODUCT_CATEGORIES}${id}`, bodyData);
//Get category list
export const category_list = () => API.get(CATEGORY_LIST);

//Job Type
export const add_job_type = (bodyData) => API.post(JOB_TYPE, bodyData);
export const edit_job_type = (id, bodyData) =>
  API.patch(`${JOB_TYPE}${id}`, bodyData);

export const job_type_list = (pageNum, filters) =>
  API.get(JOB_TYPE_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//manufacturer
export const add_manufacturer = (bodyData) => API.post(MANUFACTURER, bodyData);
export const manufacturer_list = (pageNum, filters) =>
  API.get(MANUFACTURER_LIST, {
    params: {
      page: pageNum,
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_manufacturer_by_ID = (id) => API.get(`${MANUFACTURER}${id}`);
export const edit_manufacturer = (id, bodyData) =>
  API.patch(`${MANUFACTURER}${id}`, bodyData);

//customer
export const add_customer = (bodyData) => API.post(CUSTOMER, bodyData);
export const customer_list = (pageNum, filterParams, searchString) =>
  API.get(CUSTOMER_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filterParams ? { filtersJSON: filterParams } : {}),
    },
  });

//technicians
export const add_technician = (bodyData) =>
  API.post(`${TECHNICIANS}`, bodyData);
export const technician_list = (pageNum, filtersJSON, searchString) =>
  API.get(TECHNICIANS_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const get_customer_by_ID = (id) => API.get(`${CUSTOMER}${id}`);
export const edit_customer = (id, bodyData) =>
  API.patch(`${CUSTOMER}${id}`, bodyData);
export const payment_term_list = () => API.get(PAYMENT_TERM_LIST);
export const change_customer_password = (id, bodyData) =>
  API.patch(`${CUSTOMER}${id}/change-password`, bodyData);

//cutomer service location
export const add_customer_location = (bodyData) =>
  API.post(CUSTOMER_LOCATION, bodyData);
export const customer_location_list = (
  customerId,
  pageNum,
  filters,
  searchString,
) =>
  API.get(`${CUSTOMER_LOCATION_LIST}/${customerId}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const customer_location_by_id = (customerID, locationID) =>
  API.get(`${CUSTOMER_LOCATION}${locationID}`, {
    params: {
      customerID: customerID,
    },
  });
export const edit_customer_location = (locationID, bodyData) =>
  API.patch(`${CUSTOMER_LOCATION}${locationID}`, bodyData);
export const delete_customer_location = (customerID, locationID) =>
  API.delete(`${CUSTOMER_LOCATION}${locationID}`, {
    params: {
      customerID: customerID,
    },
  });

//customer service location's region,city and country
export const region_list = () => API.get(REGION_LIST);
export const city_list = (filtersJSON) =>
  API.get(`${CITY_LIST}`, {
    params: {
      filtersJSON,
    },
  });
export const country_list = () => API.get(COUNTRY_LIST);

//product
export const add_product = (formData) =>
  API.post(PRODUCT, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const product_list = (pageNum, filters, searchString) =>
  API.get(PRODUCT_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const get_technician_by_ID = (id) => API.get(`${TECHNICIANS}${id}`);
export const edit_technician = (id, bodyData) =>
  API.patch(`${TECHNICIANS}${id}`, bodyData);
export const change_password_technician = (id, bodyData) =>
  API.patch(`${TECHNICIANS}${id}/change-password`, bodyData);

//specialization
export const specialization_list = () => API.get(SPECIALIZATION_LIST);
export const get_product_by_ID = (id) =>
  API.get(`${PRODUCT}${id}`, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const edit_product = (id, formData) =>
  API.patch(`${PRODUCT}${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//customer discount
export const add_customer_discount = (bodyData) =>
  API.post(CUSTOMER_DISCOUNT, bodyData);
export const customer_discount_list = (id, pageNum, filters) =>
  API.get(`${CUSTOMER_DISCOUNT_LIST}/${id}`, {
    params: {
      page: pageNum,
      filtersJSON: filters.filters || "",
    },
  });
export const customer_discount_by_id = (customerID, locationID) =>
  API.get(`${CUSTOMER_DISCOUNT}${locationID}`, {
    params: {
      customerID: customerID,
    },
  });
export const edit_customer_discount = (locationID, bodyData) =>
  API.patch(`${CUSTOMER_DISCOUNT}${locationID}`, bodyData);
export const delete_customer_discount = (customerID, locationID) =>
  API.delete(`${CUSTOMER_DISCOUNT}${locationID}`, {
    params: {
      customerID: customerID,
    },
  });

//Services
export const add_service = (bodyData) => API.post(SERVICE, bodyData);
export const get_service_by_ID = (id) => API.get(`${SERVICE}${id}`);
export const service_list = (pageNum, filters, searchString) =>
  API.get(SERVICE_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const edit_service = (id, bodyData) =>
  API.patch(`${SERVICE}${id}`, bodyData);

//techincian availability
export const get_technician_availability = () =>
  API.get(TECHNICIAN_AVAILABILITY);
export const get_technician_availability_by_ID = (id) =>
  API.get(`${TECHNICIAN_AVAILABILITY}${id}`);
export const add_technician_availability = (bodyData) =>
  API.post(TECHNICIAN_AVAILABILITY, bodyData);

//timeSlot
export const get_timeSlots_list = () => API.get(TIME_SLOT);

//job
export const add_job = (bodyData) => API.post(JOB, bodyData);
export const job_list = (pageNum, filtersJSON, searchString) =>
  API.get(JOB_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
export const get_job_by_ID = (id) => API.get(`${JOB}${id}`);

//Spare Parts
export const add_spare_part = (bodyData) => API.post(SPARE_PARTS, bodyData);
export const get_spare_part_list = (pageNum, filters, searchString) =>
  API.get(SPARE_PARTS_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
export const edit_spare_part = (id, bodyData) =>
  API.patch(`${SPARE_PARTS}${id}`, bodyData);
export const get_spare_part_by_ID = (id) => API.get(`${SPARE_PARTS}${id}`);

//customer equipments
export const add_customer_equipment = (bodyData) =>
  API.post(CUSTOMER_EQUIPMENT, bodyData);
export const customer_equipment_list = (
  customerId,
  locationId,
  pageNum,
  filters,
  searchString,
  warranty,
) =>
  API.get(`${CUSTOMER_EQUIPMENT_LIST}/${customerId}/location/${locationId}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
      ...(warranty ? { warranty } : {}),
    },
  });
export const customer_equipment_by_ID = (customerId) =>
  API.get(`${CUSTOMER_EQUIPMENT}${customerId}`);
export const edit_customer_equipment = (customerId, bodyData) =>
  API.patch(`${CUSTOMER_EQUIPMENT}${customerId}`, bodyData);
export const delete_customer_equipment = (equipmentId) =>
  API.delete(`${CUSTOMER_EQUIPMENT}${equipmentId}`);

// forgot password API
export const user_forgot_password = (emailData) =>
  API.post(`${FORGET_PASSWORD}`, emailData);

//reset password
export const reset_password = (emailData) =>
  API.post(`${RESET_PASSWORD}`, emailData);

//validate uuid link
export const validate_uuid = (uuid) => API.get(`${VALIDATE_UUID_LINK}${uuid}`);

//technician leave
export const add_technician_leave = (bodyData) =>
  API.post(TECHNICIAN_LEAVE, bodyData);
//list
export const get_technician_leave = (technicianId) =>
  API.get(`${TECHNICIAN_LEAVE_LIST}${technicianId}`);

export const edit_technician_leave = (id, technicianId, bodyData) =>
  API.patch(`${TECHNICIAN_LEAVE}${id}?technicianID=${technicianId}`, bodyData);
//get
export const get_technician_leave_by_ID = (id, technicianId) =>
  API.get(`${TECHNICIAN_LEAVE}${id}?technicianID=${technicianId}`);

// Job time line
export const job_time_line_by_ID = (jobId) =>
  API.get(`${JOB_TIME_LINE}${jobId}`);

// resend email invite to user/customers
export const resend_email_invite = (userID) =>
  API.patch(`${RESEND_EMAIL_INVITE}${userID}`);

//upload job uploade file
export const job_upload_files_by_ID = (jobId, formData) =>
  API.post(`${UPLOAD_JOB_FILES}${jobId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

//get quotation history
export const get_quotation_history_by_ID = (jobId) =>
  API.get(`${QUOTATION_HISTORY}${jobId}`);

//download quotation by quotation id
export const download_quotation_by_ID = (quotationId) =>
  API.get(`${QUOTATION_DOWNLOAD}${quotationId}`, {
    responseType: "blob",
  });

//validate Quotation uuid link
export const validate_quotation_uuid = (uuid) =>
  API.get(`${VALIDATE_QUOTATION_UUID}/${uuid}`);

//Approve and Reject Quotation
export const approve_and_reject_quotation = (uuid, bodyData) =>
  API.post(`${APPROVE_AND_REJECT_QUOTATION}/${uuid}`, bodyData);

// Job logs
export const job_logs_by_ID = (jobId) => API.get(`${JOB_LOGS}${jobId}`);

// Technical Report
export const add_technical_report = (bodyData) =>
  API.post(TECHNICAL_REPORT, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const edit_technical_report = (id, bodyData) =>
  API.patch(`${TECHNICAL_REPORT}${id}`, bodyData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
export const technical_report_by_ID = (id) =>
  API.get(`${TECHNICAL_REPORT}${id}`);
export const delete_technical_report_media = (mediaId, id) =>
  API.delete(`${TECHNICAL_REPORT_MEDIA}${mediaId}?technicalReportID=${id}`);

//get available dates of technician using technician id
export const available_technician_dates_by_ID = (technicianId) =>
  API.get(`${AVAILABLE_TECH_DATES}${technicianId}`);

export const reschedule_job_BY_ID = (jobId, bodyData) =>
  API.patch(`${RESCHEDULE_JOB}${jobId}`, bodyData);
//job feedback
export const get_feedback_by_ID = (jobID) => API.get(`${JOB_FEEDBACK}${jobID}`);

//get export csv product
export const product_csv_export = (filters, searchString) =>
  CsvAPI.get(EXPORT_PRODUCT_CSV, {
    params: {
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//Quotation
export const add_quotation = (bodyData) => API.post(QUOTATION, bodyData);
export const get_quotation_detail = (id) => API.get(`${QUOTATION_LIST}${id}`);
export const edit_quotation = (quotationId, jobId, body) =>
  API.patch(`${QUOTATION}${quotationId}`, body, {
    params: {
      jobID: jobId,
    },
  });
export const update_status_quotation = (body) =>
  API.patch(`${QUOTATION}update-status`, body);
export const send_quotation = (body) => API.patch(`${QUOTATION}send`, body);
export const quotation_discount_for_all = (body, jobId) =>
  API.patch(`${QUOTATION_DISCOUNT}/all/${jobId}`, body);
export const quotation_discount_on_single = (body, jobId) =>
  API.patch(`${QUOTATION_DISCOUNT}/items/${jobId}`, body);
export const requoteQuotation = (bodyData) =>
  API.post(`${REQUOTE_QUOTATION}`, bodyData);

export const get_quotation_requote_reason_list = (filters) =>
  API.get(QUOTATION_REQUOTE_LIST, {
    params: {
      page: filters.pageNum,
      ...(filters?.searchString ? { searchString: filters.searchString } : {}),
      ...(filters?.filtersJSON ? { filtersJSON: filters.filtersJSON } : {}),
    },
  });

// Get Request Parts List
export const get_Request_Spare_Parts_List = (pageNum, filters, searchString) =>
  API.get(`${REQUEST_PARTS_LIST}`, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

export const get_part_requested_list_by_id = (id) =>
  API.get(`${GET_REQUESTED_LIST_BY_ID}/${id}`);
export const update_request_parts_status = (body) =>
  API.patch(`${UPDATE_REQUESTED_PARTS_STATUS}`, body);
export const get_parts_notes_by_job_id = (jobID) =>
  API.get(`${GET_PARTS_NOTES_BY_JOB_ID}/${jobID}`);
export const update_parts_notes_by_job_id = (jobID, body) =>
  API.patch(`${UPDATE_PARTS_NOTES_BY_JOB_ID}/${jobID}`, body);

// Cancel Job
export const cancel_job = (jobId, body) =>
  API.patch(`${CANCEL_JOB}/${jobId}`, body);

// Complete Job
export const complete_job = (jobId, body) =>
  API.patch(`${COMPLETE_JOB}/${jobId}`, body);

// Equipment Manual
export const equipmentManual = (jobId) =>
  API.get(`${EQUIPMENT_MANUAL}/${jobId}`);

// Job Media
export const jobMedia = (jobId) => API.get(`${GET_JOB_MEDIA}?jobID=${jobId}`);

// Customer Service History
export const getCustomerServiceHistory = (locationID, pageNum) =>
  API.get(`${CUSTOMER_SERVICE_HISTORY}/${locationID}`, {
    params: {
      page: pageNum,
    },
  });
// Job Completed or Rework
export const jobCompletedOrRework = (jobID, bodyData) =>
  API.patch(`${JOB_COMPLETED_OR_REWORK}/${jobID}`, bodyData);

//Download Job Report
export const downloadJobReport = (jobID) =>
  API_FOR_PDF.get(`${DOWNLOAD_JOB_REPORT}/${jobID}`, {
    responseType: "blob",
  });

// export Parts Request CSV
export const exportPartsRequestedCsv = (filters = {}) => {
  const { filterJSON, searchString } = filters;
  return CsvAPI.get(EXPORT_PARTS_REQUESTED_CSV, {
    params: {
      ...(filterJSON && { filtersJSON: filterJSON }),
      ...(searchString && { searchString }),
    },
  });
};

//Continue Job
export const contiueJob = (jobId, bodyData) =>
  API.patch(`${CONTINUE_JOB}/${jobId}`, bodyData);

// job under warrenty
export const jobUnderWarrenty = (jobID, bodyData) =>
  API.patch(`${JOB_UNDER_WARRENTY}/${jobID}`, bodyData);

// Admin Note
export const adminNote = (jobID, bodyData) =>
  API.patch(`${ADMIN_NOTE}/${jobID}`, bodyData);

// assign technician
export const assign_technician = (jobID, bodyData) =>
  API.patch(`${ASSIGN_TECHNICIAN}/${jobID}`, bodyData);

// Get Checkout Id
export const generate_CheckoutID = (bodyData) =>
  API.post(`${GENERATE_CHECKOUT_ID}`, bodyData);

// Get Checkout Id
export const download_payment_receipt = (merchantID) =>
  API_FOR_PDF.get(`${DOWNLOAD_PAYMENT_RECEIPT}/${merchantID}`);

// Get Checkout Id
export const check_payment_status = (bodyData) =>
  API.post(`${GET_PAYMENT_STATUS}`, bodyData);

// edit sales order number
export const edit_sales_order_number = (jobID, bodyData) =>
  API.patch(`${EDIT_SALES_ORDER_NUMBER}/${jobID}`, bodyData);

// download job media
export const download_job_media = (jobMediaID, technicalReportID) =>
  API_FOR_PDF.get(
    `${DOWNLOAD_JOB_MEDIA}/${jobMediaID}?technicalReportID=${technicalReportID}`,
  );

// download product manual
export const download_product_manual = (productDocumentID, type) =>
  API_FOR_PDF.get(
    `${DOWNLOAD_PRODUCT_MANUAL}/${productDocumentID}?type=${type}`,
  );

//record bank transfer for quotation
export const record_bank_transfer = (jobID, bodyData) =>
  API.patch(`${RECORD_BANK_TRANSFER}?jobID=${jobID}`, bodyData);

// download equipment invoice
export const download_equipment_invoice = (equipmentID) =>
  API_FOR_PDF.get(`${DOWNLOAD_EQUIPMENT_INVOICE}/${equipmentID}`);

// job payment details
export const payment_details = (jobID) =>
  API.get(`${PAYMENT_DETAILS}?jobID=${jobID}`);

// reopen job
export const reopen_job = (jobID) => API.patch(`${REOPEN_JOB}/${jobID}`);

// internal monitoring
export const internal_monitoring = (jobID, trackingFlag) =>
  API.patch(`${INTERNAL_MONITORING}/${jobID}?trackingFlag=${trackingFlag}`);

// export Jobs CSV
export const export_jobs = (filtersJSON, searchString) => {
  return CsvAPI.get(`${EXPORT_JOBS_CSV}`, {
    params: {
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
};

// export services CSV
export const export_services = (filtersJSON, searchString) => {
  return CsvAPI.get(`${EXPORT_SERVICES_CSV}`, {
    params: {
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
}

// export spare parts CSV
export const export_spare_parts = (filtersJSON, searchString) => {
  return CsvAPI.get(`${EXPORT_SPARE_PARTS_CSV}`, {
    params: {
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON } : {}),
    },
  });
}

//get customer sub user
export const get_sub_user_list = (customerId, pageNum, filterParams) =>
  API.get(`${USER}list`, {
    params: {
      customerID: customerId,
      page: pageNum,
      ...(filterParams.searchString && {
        searchString: filterParams.searchString,
      }),
      ...(filterParams.filters?.length && {
        filtersJSON: JSON.stringify(filterParams.filters),
      }),
    },
  });

export const add_sub_user = (bodyData) => API.post(`${USER}`, bodyData);

export const get_sub_user_detail_by_id = (id, customerID) =>
  API.get(`/user/${id}?customerID=${customerID}`);

export const update_sub_user_by_id = (id, bodyData) =>
  API.patch(`${USER}${id}`, bodyData);

//assign location to sub user
export const assign_location_sub_user = (bodyData) =>
  API.post(`${ASSIGN_LOCATION_SUB_USER}`, bodyData);

//get the assign list location of sub user
export const get_list_assign_location = (
  id,
  customerID,
  params,
  filtersJSON,
  searchString,
) =>
  API.get(`${ASSIGN_LOCATION_SUB_USER}list/${id}`, {
    params: {
      customerID,
      ...params,
      ...(searchString ? { searchString } : {}),
      ...(filtersJSON ? { filtersJSON: JSON.stringify(filtersJSON) } : {}),
    },
  });

  //Download bulk work order reposrt
export const download_bulk_work_order_report = (bodyData) =>
  API_FOR_DOWNLOAD.request({
    method: "POST",
    url: DOWNLOAD_BULK_WORK_ORDER_REPORTS,
    headers: {
      "Content-Type": "application/json",
    },
    data: bodyData,
  });


//Dashboard Job Status Count

export const get_dashboard_job_status_count = (params) => {
 return API.get(DASHBOARD_JOB_STATUS,{
    params : {
      ...params
    }
  })
}; 



//Dashboard Payment Status Count
export const get_dashboard_payment_status_count = (params) => {
 return API.get(DASHBOARD_PAYMENT_STATUS,{
    params : {
      ...params
    }
  })
}; 

//Dashboard Quotation Status Count
export const get_dashboard_quotation_status_count = (params) => {
 return API.get(DASHBOARD_QUOTATION_STATUS_COUNT,{
    params : {
      ...params
    }
  })
}; 
//Dashboard Spare Parts Status Count
export const get_dashboard_spare_parts_status_count = (params) => {
 return API.get(DASHBOARD_SPARE_PARTS_STATUS_COUNT,{
    params : {
      ...params
    }
  })
}; 

//Dashboard Job Status Count
export const get_dashboard_quotation_requested_for_approval = (params) => {
 return API.get(DASHBOARD_QUOTATION_REQUESTED_FOR_APPROVAL,{
    params : {
      ...params
    }
  })
}; 

//Dashboard Job Status Count
export const get_dashboard_spare_parts_ready_for_pickup = (params) => {
 return API.get(DASHBOARD_SPARE_PARTS_READY_FOR_PICKUP,{
    params : {
      ...params
    }
  })
};

export const get_dashboard_report = (params) =>
  API.get(DASHBOARD_REPORT, { params });

export const export_dashboard_report = (params) => {
  const formData = new URLSearchParams();
  formData.set("reportType", params.reportType);
  formData.set("columns", params.columns);

  return API_FOR_DOWNLOAD.request({
    method: "GET",
    url: DASHBOARD_REPORT_EXPORT,
    params,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    data: formData.toString(),
  });
};


//Dashboard Odoo Sync Summary
export const get_dashboard_odoo_sync_summary = () => API.get(DASHBOARD_ODOO_SUMMARY);

//Dashboard Work Order Line Chart
export const get_dashboard_work_order_line_chart_data = (params) => {
 return API.get(DASHBOARD_WORK_ORDER_LINE_CHART,{
    params : {
      ...params
    }
  })
};

//Dashboard Action Required
export const get_dashboard_action_required = () => API.get(DASHBOARD_ACTION_REQUIRED);

//Dashboard Odoo Sync data
export const get_dashboard_manufacturar_not_synced_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ODOO_SYNC_SUMMARY_MANUFACTURAR, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

  //Dashboard Odoo Sync data
export const get_dashboard_customers_not_synced_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ODOO_SYNC_SUMMARY_CUSTOMERS, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

    //Dashboard Odoo Sync data
export const get_dashboard_spareParts_not_synced_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ODOO_SYNC_SUMMARY_SPARE_PARTS, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

//Dashboard Odoo Sync data
export const get_dashboard_services_not_synced_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ODOO_SYNC_SUMMARY_SERVICES, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

  //Dashboard Odoo Sync data
export const get_dashboard_quotations_not_synced_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ODOO_SYNC_SUMMARY_QUOTATIONS, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });


    //Dashboard Action Required data
export const get_dashboard_action_required_list_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_ACTION_REQUIRED_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });
 
      //Dashboard Odoo Sync data
export const get_dashboard_payment_status_failed_and_success_list_data = (
  pageNum,
  searchString,
  filters,
) =>
  API.get(DASHBOARD_PAYMENT_STATUS_FAILED_AND_SUCCESS_LIST, {
    params: {
      page: pageNum,
      ...(searchString ? { searchString } : {}),
      ...(filters?.length ? { filtersJSON: filters } : {}),
    },
  });

  export const export_csv = (params) => {
    return CsvAPI.get(EXPORT_CSV, {
      params : {
      ...params
    }
    });
  };

//Dashboard Job Status Count
export const odoo_sales = (params) => {
 return API.get(ODOO_SALES,{
    params : {
      ...params
    }
  })
};

//Dashboard Job Status Count
export const odoo_quotation_count = (params) => {
 return API.get(ODOO_QUOTATION_COUNT,{
    params : {
      ...params
    }
  })
};

//Download Job Bulk Reports 

export const download_bulk_job_reports = (bodyData) =>
  API_FOR_DOWNLOAD.request({
    method: "POST",
    url: DOWNLOAD_JOB_BULK_REPORTS,
    headers: {
      "Content-Type": "application/json",
    },
    data: bodyData,
  });


export const download_bulk_job_reports_list = () => {
  return API.get(JOB_BULK_REPORTS_EXPORT_LIST)
}

export const download_bulk_job_reports_status = (id) => {
  return API.get(`${JOB_BULK_REPORTS_STATUS}/${id}/status`)
}

export const download_bulk_job_reports_through_browser = (id) => {
  return API.get(`${DOWNLOAD_COMPLETED_BULK_REPORTS}/${id}/download`)
}

export const bulk_report = (jobIDs) =>{
  return API.get(`${BULK_REPORTS}`, jobIDs)
}

//Download Work Order Quotation Items CSV
export const download_job_quotation_items_csv = (jobIDs) =>{
  return API.post(`${DOWNLOAD_JOB_QUOTATION_ITEMS_CSV}`, jobIDs)
}
//Dashboard Payment Status Count
export const export_payment_list = () => {
 return API.get(EXPORT_PAYMENT_LIST)
};


